import {useDocumentQuery} from '@sdox/api'
import {SidePanel, PanelSizeEnum} from '@sdox/ui'
import {noop} from '@sdox/utils'

import {DocumentTypeContent} from './DocumentTypeContent'
import {MobRecordTypeContent} from './MobRecordTypeContent'
import {ErrorTypeContent} from './ErrorTypeContent'
import {EditableContextProvider} from '../../DragAndDrop'

import type {ReactNode} from 'react'

export interface DocumentButtonDialogProps {
  isOpen: boolean
  onClose: () => void
  identifier: string
}

export const DocumentButtonDialog = (props: DocumentButtonDialogProps) => {
  const {isOpen, onClose, identifier} = props

  const {loading, error, data} = useDocumentQuery({
    variables: {
      identifier,
    },
    skip: !isOpen,
    fetchPolicy: 'cache-first',
  })

  let content: ReactNode
  let heading: string | undefined = undefined

  if (loading) {
    heading = 'Dokument'
    content = <div className={'flex h-spacing-96 items-center'}>Dokument wird geladen ...</div>
  } else if (error || !data) {
    heading = 'Fehler'
    content = <div className={'flex h-spacing-96 items-center'}>Dokument konnte nicht geladen werden.</div>
  } else {
    if (data.document.__typename === 'DocumentType') {
      heading = data.document.displayName
      content = <DocumentTypeContent data={data.document} />
    } else if (data.document.__typename === 'MobRecordType') {
      heading = data.document.niceName
      content = <MobRecordTypeContent data={data.document} />
    } else if (data.document.__typename === 'ErrorType') {
      heading = 'Fehler'
      content = <ErrorTypeContent data={data.document} />
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const exhaustiveCheck: never = data.document
    }
  }

  return (
    <SidePanel
      open={isOpen}
      onClose={onClose}
      heading={heading}
      size={PanelSizeEnum.LARGE}
    >
      <EditableContextProvider value={{isEditable: false, setIsEditable: noop}}>
        {content}
      </EditableContextProvider>
    </SidePanel>
  )
}
